(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-attribute-table"] && !Shopify.designMode) return;
  try {
    
(function () {
  function escapeHtml(s) {
    return (s == null ? '' : String(s)).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function initProductTable(root) {
    if (root.__ptInit) return;
    root.__ptInit = true;

    var configEl = root.querySelector('script[data-product-table-config]');
    if (!configEl) return;
    var config;
    try {
      config = JSON.parse(configEl.textContent);
    } catch (e) {
      return;
    }

    var sectionId = config.sectionId;
    var state = { products: (config.products || []).slice(0, config.maxProducts || 5) };

    var strip = root.querySelector('[data-product-table-strip]');
    var horiz = root.querySelector('[data-product-table-horizontal]');
    var vert = root.querySelector('[data-product-table-vertical]');

    function productValues(p) {
      if (!p) return [];
      var vals;
      if (config.criteriaOption === 'product_specs') {
        vals = (p.specs && p.specs.length) ? p.specs.slice() : (p.optionsWithValues || []).slice();
        if (config.listOptionShow) {
          var remove = config.listOptionShow.split(/\r?\n/).map(function (s) { return s.trim(); }).filter(Boolean);
          vals = vals.filter(function (v) { return remove.indexOf(v) === -1; });
        }
      } else {
        vals = (p.optionsWithValues || []).slice();
      }
      var seen = {};
      var out = [];
      vals.forEach(function (v) {
        if (v && !seen[v]) { seen[v] = true; out.push(v); }
      });
      return out;
    }

    function unionAttributes() {
      var seen = {};
      var out = [];
      state.products.forEach(function (p) {
        productValues(p).forEach(function (v) {
          if (!seen[v]) { seen[v] = true; out.push(v); }
        });
      });
      return out;
    }

    function renderStrip() {
      if (!strip) return;
      var n = state.products.length || 1;
      var widthStyle = 'style="width:' + (100 / n) + '%"';
      var html = '';
      state.products.forEach(function (p, i) {
        var img = p.image
          ? '<img src="' + escapeHtml(p.image) + '" alt="' + escapeHtml(p.title) + '" loading="lazy" style="width:100%;height:auto;display:block;">'
          : '<div class="bg-[#c9c9c9] flex justify-center w-full" style="aspect-ratio:1/1;"></div>';
        html += '<div class="pt-slot md:w-[14%] pl-[5px] pr-[5px] lg:pl-3.5 lg:pr-5 lg:min-w-[180px] xxl:min-w-[300px] flex flex-col items-end" ' + widthStyle + ' data-pt-index="' + i + '">' +
          (state.products.length > (config.minProducts || 2)
            ? '<button type="button" class="pt-remove-x" data-pt-action="remove" data-pt-index="' + i + '" aria-label="Remover">&times;</button>'
            : '') +
          '<div class="overflow-hidden' + (config.roundedCorners ? ' rounded-md' : '') + ' w-full">' + img + '</div>' +
          '<div class="text-center mt-2 p-break-words w-full">' +
          '<a class="inline-block" href="' + escapeHtml(p.url) + '">' + escapeHtml(p.title) + '</a>' +
          '</div>' +
          '<div class="pt-slot-actions">' +
          '<button type="button" class="pt-btn" data-pt-action="swap" data-pt-index="' + i + '">Trocar</button>' +
          '</div>' +
          '<div class="pt-search-wrap" data-pt-search-wrap hidden></div>' +
          '</div>';
      });
      if (state.products.length < (config.maxProducts || 5)) {
        html += '<div class="pt-slot md:w-[14%] pl-[5px] pr-[5px] lg:pl-3.5 lg:pr-5 lg:min-w-[180px] xxl:min-w-[300px] flex flex-col" ' + widthStyle + ' data-pt-index="add">' +
          '<button type="button" class="pt-add-tile" data-pt-action="add" data-pt-index="add">+<br>Adicionar<br>produto</button>' +
          '<div class="pt-search-wrap" data-pt-search-wrap hidden></div>' +
          '</div>';
      }
      strip.innerHTML = html;
    }

    function renderHorizontal() {
      if (!horiz) return;
      var attrs = unionAttributes();
      var head = '<div class="flex w-full flex-col md:flex-row min-h-[55px] option-table-' + sectionId + '">' +
        '<div class="basis-52 xl:min-w-[20rem] xl:basis-[0] grow hidden md:flex"></div>';
      attrs.forEach(function (atb, i) {
        head += '<div class="options-' + (i + 1) + ' pl-10 md:pl-0 pr-5 md:pr-0 min-h-[55px] flex p-break-words grow md:basis-[0] justify-start md:justify-center items-center text-center md:ml-1 header-table-' + sectionId + ' mt-0.5 md:mt-0">' +
          '<span class="text-left md:text-center pb-2 pt-2 pl-1 pr-1 md:pt-1 md:pb-1">' + escapeHtml(atb) + '</span>' +
          '</div>';
      });
      head += '</div>';

      var rows = '';
      state.products.forEach(function (p, idx) {
        var vals = productValues(p);
        rows += '<div class="md:min-h-[55px] hidden md:flex w-full">' +
          '<div class="p-break-words hidden md:flex grow mb-[1px] items-center justify-center text-center basis-52 xl:min-w-[20rem] xl:basis-[0] bg-hightlight-' + sectionId + ' header-table-' + sectionId + ' mt-0.5' + (idx === 0 ? ' md:mt-0.5' : ' md:mt-[1px]') + '">' +
          '<a class="pl-1 pr-1 pt-2 pb-2" href="' + escapeHtml(p.url) + '">' + escapeHtml(p.title) + '</a>' +
          '</div>';
        attrs.forEach(function (atb) {
          var has = vals.indexOf(atb) !== -1;
          rows += '<div class="hidden md:flex grow basis-[0] justify-center ml-1 bg-cell-' + sectionId + ' bg-hightlight-' + sectionId + ' items-center border-solid border-b' + (idx === 0 ? ' border-t mt-0.5' : '') + '">' +
            (has ? '<span class="inline-block w-6 h-6 icon-tick opacity-70">' + config.tickIconSvg + '</span>' : '') +
            '</div>';
        });
        rows += '</div>';
      });

      horiz.innerHTML = head + rows;
    }

    function renderVertical() {
      if (!vert) return;
      var attrs = unionAttributes();
      var head = '<div class="flex w-full min-h-[55px] option-table-' + sectionId + '">' +
        '<div class="basis-32 lg:basis-52 xl:min-w-[20rem] xl:basis-[0] grow md:flex"></div>';
      state.products.forEach(function (p) {
        head += '<div class="flex p-break-words ml-1 grow basis-[0] items-center justify-center text-center bg-hightlight-' + sectionId + ' header-table-' + sectionId + ' mb-0.5">' +
          '<a class="pl-1 pr-1 pt-2 pb-2" href="' + escapeHtml(p.url) + '">' + escapeHtml(p.title) + '</a>' +
          '</div>';
      });
      head += '</div>';

      var body = '<div>';
      attrs.forEach(function (atb, ai) {
        body += '<div class="flex w-full min-h-[55px]">' +
          '<div class="p-break-words flex grow mb-[1px] items-center justify-center text-center basis-32 lg:basis-52 xl:min-w-[20rem] xl:basis-[0] header-table-' + sectionId + ' mt-0.5' + (ai === 0 ? ' md:mt-0.5' : ' md:mt-[1px]') + '">' +
          '<div class="flex p-break-words justify-center items-center text-center' + (ai !== 0 ? ' ml-0.5' : '') + ' md:ml-1 header-table-' + sectionId + '"><span class="pl-1 pr-1 pt-1 pb-1">' + escapeHtml(atb) + '</span></div>' +
          '</div>';
        state.products.forEach(function (p) {
          var vals = productValues(p);
          var has = vals.indexOf(atb) !== -1;
          body += '<div class="flex grow basis-[0] justify-center ml-1 bg-cell-' + sectionId + ' bg-hightlight-' + sectionId + ' items-center mt-[1px] border-solid border-b' + (ai === 0 ? ' border-t md:mt-[1px]' : ' md:mt-0.5') + '">' +
            (has ? '<span class="inline-block w-6 h-6 icon-tick opacity-70">' + config.tickIconSvg + '</span>' : '') +
            '</div>';
        });
        body += '</div>';
      });
      body += '</div>';

      vert.innerHTML = head + body;
    }

    function bindStripEvents() {
      if (!strip) return;
      strip.querySelectorAll('[data-pt-action]').forEach(function (el) {
        el.addEventListener('click', function (e) {
          e.stopPropagation();
          var action = el.getAttribute('data-pt-action');
          var idxAttr = el.getAttribute('data-pt-index');
          var idx = idxAttr === 'add' ? 'add' : parseInt(idxAttr, 10);
          if (action === 'remove') {
            if (state.products.length > (config.minProducts || 2)) {
              state.products.splice(idx, 1);
              renderAll();
            }
          } else if (action === 'swap' || action === 'add') {
            var slot = el.closest('.pt-slot');
            var wrap = slot && slot.querySelector('[data-pt-search-wrap]');
            if (wrap) openSearch(wrap, idx);
          }
        });
      });
    }

    var globalResultsEl = null;
    function getResultsEl() {
      if (!globalResultsEl) {
        globalResultsEl = document.createElement('div');
        globalResultsEl.className = 'pt-search-results';
        globalResultsEl.hidden = true;
        document.body.appendChild(globalResultsEl);
      }
      return globalResultsEl;
    }

    function positionResultsEl(anchorEl) {
      var el = getResultsEl();
      var rect = anchorEl.getBoundingClientRect();
      el.style.left = rect.left + 'px';
      el.style.top = (rect.bottom + 2) + 'px';
      el.style.width = rect.width + 'px';
    }

    var activeSearchInput = null;
    function repositionActiveSearch() {
      if (activeSearchInput && globalResultsEl && !globalResultsEl.hidden) {
        positionResultsEl(activeSearchInput);
      }
    }
    window.addEventListener('scroll', repositionActiveSearch, true);
    window.addEventListener('resize', repositionActiveSearch);

    function closeAllSearches() {
      if (strip) {
        strip.querySelectorAll('[data-pt-search-wrap]').forEach(function (w) {
          w.hidden = true;
          w.innerHTML = '';
        });
      }
      if (globalResultsEl) {
        globalResultsEl.hidden = true;
        globalResultsEl.innerHTML = '';
      }
      activeSearchInput = null;
    }

    var searchSeq = 0;
    function openSearch(wrap, targetIndex) {
      closeAllSearches();
      wrap.hidden = false;
      wrap.innerHTML = '<input type="text" class="pt-search-input" placeholder="Pesquisar produtos..." autocomplete="off">';
      var input = wrap.querySelector('.pt-search-input');
      var results = getResultsEl();
      results.hidden = true;
      results.innerHTML = '';
      var timer = null;
      activeSearchInput = input;
      input.focus();
      positionResultsEl(input);
      input.addEventListener('input', function () {
        var q = input.value.trim();
        clearTimeout(timer);
        if (!q) { results.hidden = true; results.innerHTML = ''; return; }
        positionResultsEl(input);
        timer = setTimeout(function () { runSearch(q, results, targetIndex, wrap); }, 300);
      });
      input.addEventListener('click', function (e) { e.stopPropagation(); });
      wrap.addEventListener('click', function (e) { e.stopPropagation(); });
    }

    function runSearch(q, results, targetIndex, wrap) {
      var seq = ++searchSeq;
      results.hidden = false;
      results.innerHTML = '<div class="pt-search-empty">A procurar...</div>';
      positionResultsEl(activeSearchInput || wrap);
      fetch(config.searchSuggestUrl + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (seq !== searchSeq) return;
          var items = (data && data.resources && data.resources.results && data.resources.results.products) || [];
          if (!items.length) {
            results.innerHTML = '<div class="pt-search-empty">Sem resultados</div>';
            return;
          }
          results.innerHTML = '';
          items.forEach(function (it) {
            var already = state.products.some(function (p, i) { return p.handle === it.handle && i !== targetIndex; });
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'pt-search-result';
            btn.innerHTML = (it.image ? '<img src="' + it.image + '" alt="">' : '') +
              '<span>' + escapeHtml(it.title) + (already ? ' (já na tabela)' : '') + '</span>';
            btn.addEventListener('click', function (e) {
              e.stopPropagation();
              selectProduct(it.handle, targetIndex, wrap);
            });
            results.appendChild(btn);
          });
        })
        .catch(function () {
          if (seq !== searchSeq) return;
          results.innerHTML = '<div class="pt-search-empty">Erro na pesquisa</div>';
        });
    }

    function selectProduct(handle, targetIndex, wrap) {
      wrap.innerHTML = '<div class="pt-search-empty">A carregar...</div>';
      fetch('/products/' + handle + '?view=compare-data')
        .then(function (r) { return r.text(); })
        .then(function (text) {
          var data = JSON.parse(text);
          if (targetIndex === 'add') {
            state.products.push(data);
          } else {
            state.products[targetIndex] = data;
          }
          if (globalResultsEl) { globalResultsEl.hidden = true; globalResultsEl.innerHTML = ''; }
          activeSearchInput = null;
          renderAll();
        })
        .catch(function () {
          wrap.hidden = false;
          wrap.innerHTML = '<div class="pt-search-empty">Não foi possível carregar o produto</div>';
        });
    }

    function renderAll() {
      renderStrip();
      renderHorizontal();
      renderVertical();
      bindStripEvents();
    }

    document.addEventListener('click', function (e) {
      var insideStrip = strip && strip.contains(e.target);
      var insideResults = globalResultsEl && globalResultsEl.contains(e.target);
      if (!insideStrip && !insideResults) closeAllSearches();
    });

    renderAll();
  }

  function boot() {
    document.querySelectorAll('[data-product-table-root]').forEach(initProductTable);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target || !e.target.querySelectorAll) return;
    e.target.querySelectorAll('[data-product-table-root]').forEach(initProductTable);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-comparison-table"] && !Shopify.designMode) return;
  try {
    
(function () {
  function escapeHtml(s) {
    return (s == null ? '' : String(s)).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  var globalResultsEl = null;
  function getResultsEl() {
    if (!globalResultsEl) {
      globalResultsEl = document.createElement('div');
      globalResultsEl.className = 'pc-search-results';
      globalResultsEl.hidden = true;
      document.body.appendChild(globalResultsEl);
    }
    return globalResultsEl;
  }

  function positionResultsEl(anchorEl) {
    var el = getResultsEl();
    var rect = anchorEl.getBoundingClientRect();
    el.style.left = rect.left + 'px';
    el.style.top = (rect.bottom + 2) + 'px';
    el.style.width = Math.max(rect.width, 220) + 'px';
  }

  var activeSearchInput = null;
  var activeWrap = null;
  function repositionActiveSearch() {
    if (activeSearchInput && globalResultsEl && !globalResultsEl.hidden) {
      positionResultsEl(activeSearchInput);
    }
  }
  window.addEventListener('scroll', repositionActiveSearch, true);
  window.addEventListener('resize', repositionActiveSearch);

  function closeSearch() {
    if (activeWrap && activeWrap.parentNode) {
      activeWrap.parentNode.removeChild(activeWrap);
    }
    activeWrap = null;
    if (globalResultsEl) {
      globalResultsEl.hidden = true;
      globalResultsEl.innerHTML = '';
    }
    activeSearchInput = null;
  }

  var searchSeq = 0;
  function openSearch(anchorEl, slotIndex, currentHandle) {
    closeSearch();
    var wrap = document.createElement('div');
    wrap.className = 'pc-search-wrap';
    wrap.innerHTML = '<input type="text" class="pc-search-input" placeholder="Pesquisar produtos..." autocomplete="off">';
    anchorEl.appendChild(wrap);
    activeWrap = wrap;
    var input = wrap.querySelector('.pc-search-input');
    activeSearchInput = input;
    input.focus();
    var results = getResultsEl();
    results.hidden = true;
    results.innerHTML = '';
    positionResultsEl(input);
    var timer = null;
    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (!q) { results.hidden = true; results.innerHTML = ''; return; }
      positionResultsEl(input);
      timer = setTimeout(function () { runSearch(q, results, slotIndex, currentHandle); }, 300);
    });
    input.addEventListener('click', function (e) { e.stopPropagation(); });
    wrap.addEventListener('click', function (e) { e.stopPropagation(); });
  }

  function runSearch(q, results, slotIndex, currentHandle) {
    var seq = ++searchSeq;
    results.hidden = false;
    results.innerHTML = '<div class="pc-search-empty">A procurar...</div>';
    if (activeSearchInput) positionResultsEl(activeSearchInput);
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (seq !== searchSeq) return;
        var items = (data && data.resources && data.resources.results && data.resources.results.products) || [];
        if (!items.length) {
          results.innerHTML = '<div class="pc-search-empty">Sem resultados</div>';
          return;
        }
        results.innerHTML = '';
        items.forEach(function (it) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'pc-search-result';
          btn.innerHTML = (it.image ? '<img src="' + it.image + '" alt="">' : '') +
            '<span>' + escapeHtml(it.title) + (it.handle === currentHandle ? ' (produto atual)' : '') + '</span>';
          btn.addEventListener('click', function (e) {
            e.stopPropagation();
            swapProduct(slotIndex, it.handle);
          });
          results.appendChild(btn);
        });
      })
      .catch(function () {
        if (seq !== searchSeq) return;
        results.innerHTML = '<div class="pc-search-empty">Erro na pesquisa</div>';
      });
  }

  function swapProduct(slotIndex, handle) {
    closeSearch();
    fetch('/products/' + handle + '?view=compare-fragment')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newRows = doc.querySelectorAll('[data-row-key]');
        var table = document.getElementById('product-comparison-table');
        if (!table) return;
        newRows.forEach(function (newRow) {
          var rowKey = newRow.getAttribute('data-row-key');
          var liveRow = table.querySelector('.compare-block[data-row-key="' + rowKey + '"]');
          if (!liveRow) return;
          var newChild = newRow.firstElementChild;
          if (!newChild) return;
          var oldChild = liveRow.querySelector('[data-slot="' + slotIndex + '"]');
          newChild.setAttribute('data-slot', slotIndex);
          newChild.setAttribute('data-product-handle', handle);
          if (oldChild) {
            var widthClass = (oldChild.className.match(/md:w-1\/\d+/) || [])[0];
            if (widthClass) {
              newChild.className = newChild.className.replace(/md:w-1\/\d+/, widthClass);
            }
            oldChild.replaceWith(newChild);
          } else {
            liveRow.appendChild(newChild);
          }
        });
      })
      .catch(function () {
        console.error('[product-comparison-table] Nao foi possivel trocar o produto.');
      });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('[data-swap-trigger]');
    if (trigger) {
      e.preventDefault();
      var slotEl = trigger.closest('[data-slot]');
      if (!slotEl) return;
      var slotIndex = slotEl.getAttribute('data-slot');
      var currentHandle = slotEl.getAttribute('data-product-handle');
      var anchor = trigger.parentElement || slotEl;
      openSearch(anchor, slotIndex, currentHandle);
      return;
    }
    var insideResults = globalResultsEl && globalResultsEl.contains(e.target);
    var insideWrap = activeWrap && activeWrap.contains(e.target);
    if (!insideResults && !insideWrap) closeSearch();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
